/* eslint-disable import/prefer-default-export */

export default {
  TOGGLE_EXPAND_ITEM: 'UI_STATE/TOGGLE_EXPAND_ITEM',
  EXPAND_ALL: 'UI_STATE/EXPAND_ALL',
  COLLAPSE_ALL: 'UI_STATE/COLLAPSE_ALL',
  SAVE_PRODUCT_DESIGN_ALERT: 'SAVE_PRODUCT_DESIGN_ALERT',
  SAVE_PRODUCT_DESIGN_ALERT_DISMISS: 'SAVE_PRODUCT_DESIGN_ALERT_DISMISS',
  CONTROL_NEW_DESIGN_MODAL: 'CONTROL_NEW_DESIGN_MODAL',
  CONTROL_WINDOWS_WITH_INVALID_CONFIGURATIONS_MODAL: 'CONTROL_WINDOWS_WITH_INVALID_CONFIGURATIONS_MODAL',
};
